import { AppShell } from '@mantine/core';
import { cashdesksPageModel } from 'pages/cashdesks-page/model';
import { createAddCashdeskModal } from 'features/add-cashdesk';
import { createBlockCashdeskModal } from 'features/block-cashdesk';
import { createDeleteCashdeskModal } from 'features/delete-cashdesk';
import { createDepositCashdeskModal } from 'features/deposit-cashdesk';
import { createEditCashdeskModal } from 'features/edit-cashdesk';
import { createUnblockCashdeskModal } from 'features/unblock-cashdesk';
import { createWithdrawCashdeskModal } from 'features/withdraw-cashdesk';
import { createCashdeskRegistry } from 'entities/cashdesk';
import cls from './cashdesks-page.module.scss';

const CashdeskRegistry = createCashdeskRegistry(cashdesksPageModel.cashdeskRegistryModel);

const AddCashdeskModal = createAddCashdeskModal(cashdesksPageModel.addCashdeskModel);

const DepositCashdeskModal = createDepositCashdeskModal(cashdesksPageModel.depositCashdeskModel);

const WithdrawCashdeskModal = createWithdrawCashdeskModal(cashdesksPageModel.withdrawCashdeskModel);

const EditCashdeskModal = createEditCashdeskModal(cashdesksPageModel.editCashdeskModel);

const BlockCashdeskModal = createBlockCashdeskModal(cashdesksPageModel.blockCashdeskModel);

const UnblockCashdeskModal = createUnblockCashdeskModal(cashdesksPageModel.unblockCashdeskModel);

const DeleteCashdeskModal = createDeleteCashdeskModal(cashdesksPageModel.deleteCashdeskModel);

export const CashdesksPage = () => (
	<>
		<AppShell.Main className={cls.cashdesksPage}>
			<CashdeskRegistry
				className={cls.cashdesksPageCashdeskRegistry}
				emptyActionSlot={<AddCashdeskModal.Button />}
				topBarActionSlot={<AddCashdeskModal.Button />}
				tableTdActionSlot={(cashdesk) => (
					<div className={cls.cashdesksPageActions}>
						<div className={cls.cashdesksPageActionsGroup}>
							<DepositCashdeskModal.Button
								fullWidth
								modalData={cashdesk}
							/>
							<WithdrawCashdeskModal.Button
								fullWidth
								modalData={cashdesk}
							/>
						</div>
						<div className={cls.cashdesksPageActionsGroup}>
							<EditCashdeskModal.ActionIcon modalData={cashdesk} />
							{cashdesk.isLocked ? (
								<UnblockCashdeskModal.ActionIcon modalData={cashdesk} />
							) : (
								<BlockCashdeskModal.ActionIcon modalData={cashdesk} />
							)}
							<DeleteCashdeskModal.ActionIcon modalData={cashdesk} />
						</div>
					</div>
				)}
			/>
		</AppShell.Main>
		<DepositCashdeskModal />
		<EditCashdeskModal />
		<BlockCashdeskModal />
		<UnblockCashdeskModal />
		<DeleteCashdeskModal />
		<AddCashdeskModal />
		<WithdrawCashdeskModal />
	</>
);
